import { useInterviewSession } from '@hooks/interview/useInterviewSession';
import { isLogin } from '@stores/selectors/loginInfo';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

export function useCondition() {
  const isUserLoggedIn = useAtomValue(isLogin);
  const { getInterviewInfo } = useInterviewSession();
  const { name, certificationCode, valuerSn, apiUrl, intervieweeName } =
    getInterviewInfo();

  const hasMeetingCondition = useMemo(
    () => name && certificationCode && valuerSn && apiUrl,
    [apiUrl, certificationCode, name, valuerSn],
  );

  const hasInterviewerMeetingCondition = useMemo(
    () => name && intervieweeName && certificationCode && valuerSn && apiUrl,
    [apiUrl, certificationCode, intervieweeName, name, valuerSn],
  );

  return {
    isUserLoggedIn,
    hasMeetingCondition,
    hasInterviewerMeetingCondition,
  };
}
